<dx-popup
    #workOrderSelector
    width="60%"
    height="70%"
    title="Work Orders"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onWorkOrderShown()"
    (onHidden)="onWorkOrderClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <app-work-order
                        [isPopup]="true"
                        [communityId]="communityId"
                        [vendorId]="vendorId"
                        [workOrderIds]="workOrderIds"
                        (onWorkOrderSelection)="onWorkOrderIdSelection($event)"
                    ></app-work-order>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="toolbar-container">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onWorkOrderClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Select"
                                    [icon]="iconCheck"
                                    (onClick)="onWorkOrderSelect()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
